// Hard coded data for webshop
let images = require.context('./product-images/', false, /\.(png|jpeg|jpg|svg|webp)$/);
let paths = images.keys().map(images);

export const ProductData = {
    "001": {
        "name": "Black ColorFit Bluetooth Calling Smart Watch with Voice Assistance", 
        "brand": "NOISE", 
        "image": paths[0], 
        "price": 3299,
        "old_price": 4999,
        "ratings": 4.2,
        "reviews": "3.3k",
        "category": "Watches",
        "images": [paths[0]],
        "variant_data": {"Size": ["S", "M", "L", "XL"], "Color": ["White", "Black"]},
        "description": `With better sound.& clarity.Perfecting the path from artist to ear. So that music sounds just as it was intended.
            A new dual chamber speaker design and our 11.6 mm dynamic driver ensures playback reveals every detail.. For even richer high notes, and effortlessly powerful bass.
            Transporting you to the recording studio, wherever you are. Ear (2) is Hi-Res Audio certified and supports LHDC 5.0 for high-resolution streaming over Bluetooth.
            For powerfully pure audio with no quality damage.
            Silence the unwanted noise with Active Noise Cancellation (ANC) up to 40db.
            Switch between three levels of ANC or let Ear (2) take control.
            Adaptive Mode detects distractions in your environment before you do. Or take your listening to the next level with Personalised ANC.
            Noise cancellation tailored to the exact shape of your ears.Ear (2) celebrates the beauty of raw technology and expert craftsmanship with a design thats wonderfully original.
            We made the transparent charging case with a glass-like, pressure-resistant material for a premium feel
            Warranty: 1 year
            Warranty provided by Brand/Manufacturer`,
        "specifications": {
            "General": [
                {"key": "Model Name", "value": "Ear (2)"}, 
                {"key": "Headphone Type", "value": "Wireless"},
                {"key": "Inline Remote", "value": "Yes"},
                {"key": "Sales Package", "value": "Ear (2), Wireless Charging Case, USB-C Charging Cable, User Manual, Safety Information, Warranty Card"},
                {"key": "Connectivity", "value": "Bluetooth"},
                {"key": "Headphone Design", "value": "Earbud"},
            ],
            "Product Details": [
                {"key": "Driver Type", "value": "Dynamic"}, 
                {"key": "Driver Size", "value": "10 mm"},
                {"key": "Water Resistant", "value": "Yes"},
                {"key": "Sweat Proof", "value": "Yes"},
                {"key": "Deep Bass", "value": "Yes"},
                {"key": "With Microphone", "value": "Yes"},
            ],
            "Connectivity Features": [
                {"key": "Bluetooth Version", "value": "5.2"},
                {"key": "Bluetooth Range", "value": "10 m"},
                {"key": "Bluetooth Profiles", "value": "HFP/HSP/AVRCP/A2DP"},
                {"key": "Headphone Power Source", "value": "Battery"},
            ]
        }
    },
    "002": {
        "name": "Nothing Ear 2 Dual connection Bluetooth Headset (White, True Wireless)",
        "brand": "Nothing",
        "image": paths[15],
        "price": 9999,
        "old_price": 12999,
        "ratings": "4.3",
        "reviews": "250",
        "category": "Earphones",
        "images": [paths[15], paths[16], paths[17], paths[18], paths[19], paths[20], paths[21]],
        "variant_data": {"Size": ["S", "M", "L", "XL"], "Color": ["White", "Black"]},
        "description": `With better sound.& clarity.Perfecting the path from artist to ear. So that music sounds just as it was intended.
            A new dual chamber speaker design and our 11.6 mm dynamic driver ensures playback reveals every detail.. For even richer high notes, and effortlessly powerful bass.
            Transporting you to the recording studio, wherever you are. Ear (2) is Hi-Res Audio certified and supports LHDC 5.0 for high-resolution streaming over Bluetooth.
            For powerfully pure audio with no quality damage.
            Silence the unwanted noise with Active Noise Cancellation (ANC) up to 40db.
            Switch between three levels of ANC or let Ear (2) take control.
            Adaptive Mode detects distractions in your environment before you do. Or take your listening to the next level with Personalised ANC.
            Noise cancellation tailored to the exact shape of your ears.Ear (2) celebrates the beauty of raw technology and expert craftsmanship with a design thats wonderfully original.
            We made the transparent charging case with a glass-like, pressure-resistant material for a premium feel
            Warranty: 1 year
            Warranty provided by Brand/Manufacturer`,
        "specifications": {
            "General": [
                {"key": "Model Name", "value": "Ear (2)"}, 
                {"key": "Headphone Type", "value": "Wireless"},
                {"key": "Inline Remote", "value": "Yes"},
                {"key": "Sales Package", "value": "Ear (2), Wireless Charging Case, USB-C Charging Cable, User Manual, Safety Information, Warranty Card"},
                {"key": "Connectivity", "value": "Bluetooth"},
                {"key": "Headphone Design", "value": "Earbud"},
            ],
            "Product Details": [
                {"key": "Driver Type", "value": "Dynamic"}, 
                {"key": "Driver Size", "value": "10 mm"},
                {"key": "Water Resistant", "value": "Yes"},
                {"key": "Sweat Proof", "value": "Yes"},
                {"key": "Deep Bass", "value": "Yes"},
                {"key": "With Microphone", "value": "Yes"},
            ],
            "Connectivity Features": [
                {"key": "Bluetooth Version", "value": "5.2"},
                {"key": "Bluetooth Range", "value": "10 m"},
                {"key": "Bluetooth Profiles", "value": "HFP/HSP/AVRCP/A2DP"},
                {"key": "Headphone Power Source", "value": "Battery"},
            ]
        }
    },
    "003": {
        "name": "boAt Airdopes 441 Pro True Wireless Earbuds", 
        "brand": "boAt", 
        "image": paths[2], 
        "price": 1899,
        "old_price": 6990,
        "ratings": 3.9,
        "reviews": "19k",
        "category": "Earphones",
        "images": [paths[2]],
        "variant_data": {"Size": ["S", "M", "L", "XL"], "Color": ["White", "Black"]},
        "description": `With better sound.& clarity.Perfecting the path from artist to ear. So that music sounds just as it was intended.
            A new dual chamber speaker design and our 11.6 mm dynamic driver ensures playback reveals every detail.. For even richer high notes, and effortlessly powerful bass.
            Transporting you to the recording studio, wherever you are. Ear (2) is Hi-Res Audio certified and supports LHDC 5.0 for high-resolution streaming over Bluetooth.
            For powerfully pure audio with no quality damage.
            Silence the unwanted noise with Active Noise Cancellation (ANC) up to 40db.
            Switch between three levels of ANC or let Ear (2) take control.
            Adaptive Mode detects distractions in your environment before you do. Or take your listening to the next level with Personalised ANC.
            Noise cancellation tailored to the exact shape of your ears.Ear (2) celebrates the beauty of raw technology and expert craftsmanship with a design thats wonderfully original.
            We made the transparent charging case with a glass-like, pressure-resistant material for a premium feel
            Warranty: 1 year
            Warranty provided by Brand/Manufacturer`,
        "specifications": {
            "General": [
                {"key": "Model Name", "value": "Ear (2)"}, 
                {"key": "Headphone Type", "value": "Wireless"},
                {"key": "Inline Remote", "value": "Yes"},
                {"key": "Sales Package", "value": "Ear (2), Wireless Charging Case, USB-C Charging Cable, User Manual, Safety Information, Warranty Card"},
                {"key": "Connectivity", "value": "Bluetooth"},
                {"key": "Headphone Design", "value": "Earbud"},
            ],
            "Product Details": [
                {"key": "Driver Type", "value": "Dynamic"}, 
                {"key": "Driver Size", "value": "10 mm"},
                {"key": "Water Resistant", "value": "Yes"},
                {"key": "Sweat Proof", "value": "Yes"},
                {"key": "Deep Bass", "value": "Yes"},
                {"key": "With Microphone", "value": "Yes"},
            ],
            "Connectivity Features": [
                {"key": "Bluetooth Version", "value": "5.2"},
                {"key": "Bluetooth Range", "value": "10 m"},
                {"key": "Bluetooth Profiles", "value": "HFP/HSP/AVRCP/A2DP"},
                {"key": "Headphone Power Source", "value": "Battery"},
            ]
        }
    },
    "004": {
        "name": "Black AirBass XPods True Wireless Bluetooth Earbuds", 
        "brand": "BOULT AUDIO", 
        "image": paths[3], 
        "price": 1299,
        "old_price": 4999,
        "ratings": 3.3,
        "reviews": "2.3k",
        "category": "Earphones",
        "new": true
    },
    "005": {
        "name": "Black Solid Pulse Ace Bluetooth Calling Fitness Smartwatch", 
        "brand": "HAMMER", 
        "image": paths[4], 
        "price": 1499,
        "old_price": 3999,
        "ratings": 3.8,
        "reviews": "26",
        "category": "Watches",
        "images": [paths[4]],
    },
    "006": {
        "name": "Blue Solid Wired In Ear Headphones", 
        "brand": "Kratos", 
        "image": paths[5], 
        "price": 599,
        "old_price": 599,
        "ratings": 3.8,
        "reviews": "26",
        "category": "Headphones",
        "images": [paths[5]],
    },
    "007": {
        "name": "Men Grey The Carlyle HR Gen 5 Smartwatch FTW4024", 
        "brand": "Fossil", 
        "image": paths[6], 
        "price": 14995,
        "old_price": 22995,
        "ratings": 4.1,
        "reviews": "359",
        "category": "Watches",
        "new": true,
        "images": [paths[6]],
    },
    "008": {
        "name": "Ninja Unisex Touch to Wake SpO2 Smartwatch 07BSWAAY - Beige", 
        "brand": "Fire-Boltt", 
        "image": paths[7], 
        "price": 1499,
        "old_price": 4999,
        "ratings": 4.1,
        "reviews": "4k",
        "category": "Watches",
        "images": [paths[7]],
    },
    "009": {
        "name": "IdeaPad 3 Core i3 11th Gen - (8 GB/512 GB SSD/Windows 11 Home)", 
        "brand": "Lenovo", 
        "image": paths[8], 
        "price": 40990,
        "old_price": 59390,
        "ratings": 4.2,
        "reviews": "3k",
        "category": "Laptops",
        "images": [paths[8]],
    },
    "010": {
        "name": "K617 Fizz 60% Wired RGB Gaming Keyboard, 61 Keys", 
        "brand": "Redragon", 
        "image": paths[9], 
        "price": 2649,
        "old_price": 3499,
        "ratings": 4.7,
        "reviews": "1.3k",
        "category": "Keyboards",
        "images": [paths[9]],
    },
    "011": {
        "name": "Nord CE 2 Lite 5G (Blue Tide, 128 GB)  (6 GB RAM)", 
        "brand": "OnePlus", 
        "image": paths[10], 
        "price": 19999,
        "old_price": 19999,
        "ratings": 4.4,
        "reviews": "26.7k",
        "category": "Mobiles",
        "new": true,
        "images": [paths[10]],
    },
    "012": {
        "name": "Black Solid Portable Bluetooth Speaker", 
        "brand": "JBL", 
        "image": paths[11], 
        "price": 24999,
        "old_price": 29999,
        "ratings": "--",
        "reviews": "--",
        "category": "Speakers",
        "images": [paths[11]],
    },
    "013": {
        "name": "Wings Phantom Black & Green Gaming True Wireless Earbuds With 65 ms Latency", 
        "brand": "WINGS", 
        "image": paths[12], 
        "price": 1499,
        "old_price": 4999,
        "ratings": "4.2",
        "reviews": "12k",
        "category": "Earphones",
        "new": true,
        "images": [paths[12]],
    },
    "014": {
        "name": "Pink & Black Luxe Lunar Sleep Tracking Stress & Heart Rate Fitness Band", 
        "brand": "Fitbit", 
        "image": paths[13], 
        "price": 9799,
        "old_price": 10999,
        "ratings": "4.2",
        "reviews": "6",
        "category": "Watches",
        "images": [paths[13]],
    },
    "015": {
        "name": "Unisex Grey Ring Bluetooth Calling Smartwatch with SpO2 05BSWAAY3", 
        "brand": "Fire-Boltt", 
        "image": paths[14], 
        "price": 2999,
        "old_price": 9999,
        "ratings": "4",
        "reviews": "69",
        "category": "Watches",
        "images": [paths[14]],
    },
    "016": {
        "name": "Black Ninja Call 2 Bluetooth Calling Smart Watch 25BSWAAY#1", 
        "brand": "Fire-Boltt", 
        "image": paths[1], 
        "price": 2999,
        "old_price": 7999,
        "ratings": 4.3,
        "reviews": "4.7k",
        "category": "Watches",
        "images": [paths[1]],
    }
}

